import React, { MouseEvent, PropsWithChildren, ReactNode } from 'react';
import styled from 'styled-components';

import ActionButton from './ActionButton';
import Sparkles from '../icons/Sparkles';

interface Props {
  buttonText: ReactNode;
  disabled: boolean;
  onClick?: (e: MouseEvent) => void;
}

const SparkleButton = ({ buttonText, disabled, onClick }: PropsWithChildren<Props>) => {
  return <ButtonContainer>
    <ActionButton onClick={onClick} disabled={disabled} lessPadding={true}>
      <SparklesContainer>
        <Sparkles size={24} color="var(--button-text-color)"></Sparkles>
      </SparklesContainer>
      <TextWrapper>{buttonText}</TextWrapper>
    </ActionButton>
  </ButtonContainer>;
};


export default SparkleButton;

const TextWrapper = styled.div`
  justify-content: center;
  align-content: center;
  align-items: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 300;
  line-height: 160%; /* 28.8px */
  margin: 10px 10px;
`;

export const ButtonContainer = styled.div`
  width: 100%;
  padding: 2px;
  display: flex;
  flex-direction: row;
  z-index: 100;
  justify-content: center;
`;

export const SparklesContainer = styled.div`
  margin-top: 5px;
`;

